<template>
  <div class="paymentContent" v-if="isLogined">
    <div class="paymentInfo">
      <div class="title">
        <div class="titleLabel">选择付款方式</div>
        <div class="orderCodeLabel" :title="orderCodes">订单号：{{omitString(orderCodes,39)}}</div>
      </div>
      <div class="content">
        <div class="head">支付方式</div>
        <div class="orderInfo">
            <div :title="orderCodes">订单号：{{omitString(orderCodes,28)}}</div><div>实付：￥{{Number(totalAmount).toFixed(2)}}</div>
        </div>
        <div class="payType">
          <el-radio-group v-model="payType">
              <!-- <el-radio :label="1"><img src="http://img.static.knnnj.com/Default/4ba3ff8b-0d9d-4de2-b289-356f2c0cbe0e.png"></el-radio> -->
              <el-radio :label="2"><img src="http://img.static.knnnj.com/Default/6bb4e732-162f-4cae-9bff-2b4f2e3d6797.png"></el-radio>
              <!-- <el-radio :label="3"><img src="http://img.static.knnnj.com/Default/04113184-e619-43d4-a937-a71899c20719.png"></el-radio> -->
          </el-radio-group>
        </div>
      </div>
      <div class="footer">
        <input type="button" value="立即付款" @click="paySuc">
        <div>剩余付款时间：<span>{{countDownContent}}</span></div>
      </div>
    </div>
  </div>
  <div class="paymentContent1" v-else>
    <div @click="toLogin()">亲,请先登陆</div>
  </div>
</template>
<style>
@import '../../styles/payment.css';
</style>
<script>
  import api from '@/api'
  import { getStore, setStore } from '@/utils/storage'
  import { getMultipleOrder } from '@/api/order'
  import { mapMutations, mapState } from 'vuex'
  import Util from '@/utils/util'
  import { clearInterval, setTimeout, clearTimeout } from 'timers';
  export default {
    data () {
      return {
        payType: 2,
        countDownContent:'',
        countDown:0,
        timer:null,
        totalAmount:0,
        orderCodes:'',
        orderList:{},

        payNow: '立刻支付',
        submit: true,
        orderId: '',
        type: '',
        maxLength: 30,
        freight:0
      }
    },
    computed: {
      ...mapState(['isLogined']), 
    },
    methods: {
      toLogin() {
      this.$router.push({ name: 'userLogin' })
      },
      messageFail (m) {
        this.$message.error({ message: m })
      },      
      goodsDetails (id) {
        this.countDown = 0;
        window.open(window.location.origin + '#/goodsDetails?productId=' + id)
      },
      paySuc () {
        this.payNow = '支付中...'
        this.submit = false
        if (this.payType === 1) {
          this.type = 'Alipay'
        } else if (this.payType === 2) {
          this.type = 'Wechat'
        }else {
          this.type = '其它'
        }
        
        this.countDown = 0;
        if (this.payType === 1) {
          this.$router.push({path: '/order/alipay',query: {orderId: this.orderId}})
        } else if (this.payType === 2) {
          this.$router.push({path: '/order/wechat',query: {orderId: this.orderId}})
        } else if (this.payType === 3) {
          this.$router.push({path: '/order/qqpay'})
        } else {
          this.$router.push({path: '/order/alipay'})
        }  
      },
      omitString(str, saveLength)
      {
        var temp = str;       
        if(temp.length>saveLength)
        {
            temp = temp.substr(0,saveLength)+"...";
        }
        return temp;
      },
      countDownFun()
      {
        debugger;
        if(this.countDown>0)
        {
           this.countDown--;
           var minutes = Math.floor(this.countDown/(60));
           var sec = Math.floor(this.countDown%60)
           var tempTime = '';
           if(minutes>0)tempTime = (minutes>9? minutes:'0'+ minutes) +'分';
           tempTime += (sec>9? sec:'0'+ sec) +'秒';
           this.countDownContent= tempTime;
           var _this=this;          
           setTimeout(() => {
              _this.countDownFun()
            }, 1000)
        }
        else 
        {
          this.countDownContent='已过期';
           return;
        }   
      },     
    },

    created () {
      if(this.isLogined)
      {      
        this.orderId = this.$route.query.orderId
        if (this.orderId) {
          var orderIds = [];
          if(this.orderId instanceof Array)
          {
            for(var x=0;x<this.orderId.length;x++)
            {
              orderIds.push(this.orderId[x]);
            }
          }
          else
          {
             orderIds.push(this.orderId);
          }          
          var _this=this;
          getMultipleOrder({orderIds:orderIds}).then(res=>{        
            _this.orderList = res.data.result;
            debugger;
            _this.orderCodes='';
            for(var i=0;i<_this.orderList.length;i++)
            {
              _this.totalAmount = _this.totalAmount + _this.orderList[i].payableAmount
              _this.orderCodes += _this.orderList[i].orderCode;
              if(i!=(_this.orderList.length-1)) _this.orderCodes += '、';
            }
            const nowTimestamp = new Date(_this.orderList[0].creationTime).getTime();
            var expire = new Date(nowTimestamp + 30 * 60 * 1000).getTime();
            var current = new Date().getTime();
            var usedTime = expire-current;
            _this.countDown = Math.floor(usedTime/1000);
            _this.countDownFun()
          })
        } else {
          this.$router.push({path: '/'})
        }
      }
      else
      {
        this.$router.push({ name: 'userLogin' })
      }
    },
    components: {
    }
  }
</script>



// WEBPACK FOOTER //
// payment.vue?2f980044